<template>
	<div class="index container">
		<List />
	</div>
</template>

<script>
import List from '@/components/home/List'


export default {
	name: "Index",
	components: { List },
	data() {
		return {
		}
	},
}
</script>

<style>
.index {
	max-width: 600px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/Index.vue